export default __webpack_public_path__ + "16d084367e92127420afc5228f122c66.svg";